import Swiper, { Autoplay } from 'swiper';

export default function initCarousel() {
    const sliders = document.querySelectorAll('[data-swiper]');

    sliders.forEach(slider => {
        let autoplay = slider.dataset.autoplay ? {
            delay: slider.dataset.autoplayDelay ? slider.dataset.autoplayDelay : 0,
        } : '';

        let spaceBetween =
            slider.dataset.spacebetween
                ? +slider.dataset.spacebetween
                : 19;

        let speed =
            slider.dataset.speed
                ? +slider.dataset.speed
                : 3000;

        let loop =
            slider.dataset.loop
                ? slider.dataset.loop
                : false;

        let slidesPerView =
            slider.dataset.slidesperView ?
                slider.dataset.slidesperView :
                'auto';

        const mySwiper = new Swiper(slider, {
            modules: [Autoplay],
            init: true,
            grabCursor: true,
            spaceBetween,
            slidesPerView,
            loop,
            speed,
            autoplay,
            breakpoints: {
                1280: {
                    spaceBetween: 24,
                },
            },
            on: {
                init() {
                    if (this.el.hasAttribute('data-autoplay')) {
                        this.el.addEventListener('mouseenter', () => {
                            this.autoplay.stop();
                            this.speed = 0;
                        });

                        this.el.addEventListener('mouseleave', () => {
                            this.autoplay.start();
                            this.speed = slider.dataset.speed || 3000;
                        });
                    }
                },
            },
        });
    })
};
